import React from "react";
import { Link } from "react-router-dom";

const FooterCard = () => {

    const handleContextMenu = (event) => {
      event.preventDefault(); 
    };
  return (
    <div className="absolute left-0 right-0 -top-[350px] md:-top-[230px] mx-auto max-w-[1440px] lg:max-w-[1100px] md:max-w-[800px] sm:max-w-[600px]">
      <div className="grid grid-cols-1 md:grid-cols-2 mx-4 md:mx-12">
        <div className="flex flex-col items-center md:items-start bg-[#296D9C] justify-between text-white md:rounded-l-2xl rounded-t-2xl md:rounded-r-none p-8 md:p-4 lg:p-10 text-center md:text-start ">
          <h2 className="lg:text-3xl  md:text-xl sm:text-2xl text-xl mb-4 text-justify ">
            Experience reliable seaborne energy trade and build a long-term
            relationship with Seven Islands Shipping Limited
          </h2>
          <Link to="/getintouch">
            <button className="flex items-center gap-2 p-2 rounded-lg bg-[#FF8730] hover:bg-yellow-500 text-white w-44 justify-center">
              Let's Talk
              <img
                src="/assets/letsTalk.png"
                alt="Lets Talk"
                className="w-4 h-4"
              />
            </button>
          </Link>
        </div>
        <div className="md:rounded-br-2xl rounded-br-2xl  md:rounded-bl-none rounded-bl-2xl md:rounded-tr-2xl  overflow-hidden">
          <img
            src="/Images/Ships/centuryTwo.png"
            alt="Shipping Solutions"
            className="w-full md:h-80 h-48"
            onContextMenu={handleContextMenu}
          />
        </div>
      </div>
    </div>
  );
};

export default FooterCard;
